var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isManager
    ? _c(
        "div",
        { attrs: { id: "btn-edit-rates" } },
        [
          _vm.isCompanySelected
            ? [
                _c(
                  "v-btn",
                  {
                    staticClass: "btn-editRates",
                    attrs: { outlined: "" },
                    on: {
                      click: function ($event) {
                        return _vm.openEditRatesModal()
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "text-none text-body-1-bold text--text text--base",
                      },
                      [_vm._v(_vm._s(_vm.$t("sEditRates.editRates")))]
                    ),
                  ]
                ),
              ]
            : [
                _c(
                  "span",
                  { staticClass: "text-body-3 text--text text--base" },
                  [_vm._v(_vm._s(_vm.$t("sEditRates.selectCompany")))]
                ),
              ],
          _vm._v(" "),
          _c("EditRatesModal", {
            attrs: {
              isOpen: _vm.showEditRatesModal,
              onCloseModal: _vm.closeEditRatesModal,
              onShowPopUp: _vm.showPopUp,
            },
          }),
          _vm._v(" "),
          _c("SPopUp", {
            attrs: {
              isOpen: _vm.popUpData.isOpen,
              sText: _vm.popUpData.message,
              isValid: _vm.popUpData.isValid,
            },
            on: { close: _vm.closePopUp },
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }